/**
 * Tiny time helpers — kept dependency-free so we don't ship dayjs/date-fns
 * for one formatting use case. If the requirements grow (i18n, calendars),
 * promote this to date-fns; the API surface here mirrors theirs.
 */

const UNITS = [
  { seconds: 60 * 60 * 24 * 365, label: 'y' },
  { seconds: 60 * 60 * 24 * 30, label: 'mo' },
  { seconds: 60 * 60 * 24 * 7, label: 'w' },
  { seconds: 60 * 60 * 24, label: 'd' },
  { seconds: 60 * 60, label: 'h' },
  { seconds: 60, label: 'm' },
];

/**
 * formatRelative — "5m ago" / "2h ago" / "3d ago" / "Just now".
 * Uses absolute units (no localisation) — matches FOM's English-first launch.
 */
export function formatRelative(iso, now = Date.now()) {
  const t = typeof iso === 'string' ? new Date(iso).getTime() : iso;
  const diffSec = Math.max(0, Math.floor((now - t) / 1000));
  if (diffSec < 45) return 'Just now';
  for (const u of UNITS) {
    if (diffSec >= u.seconds) {
      const v = Math.floor(diffSec / u.seconds);
      return `${v}${u.label} ago`;
    }
  }
  return `${diffSec}s ago`;
}

/**
 * formatRaceDate — "Sun 3 May · 19:30 UTC". Used for race-meeting headers.
 */
export function formatRaceDate(iso) {
  const d = new Date(iso);
  const day = d.toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'short' });
  const time = d.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit', timeZone: 'UTC' });
  return `${day} · ${time} UTC`;
}
